module.exports = ".row{\r\n    padding: 1em 0px 0px 0px !important;\r\n    margin-bottom: -3px;\r\n}\r\n\r\n\r\n.row:nth-child(odd){\r\n    background: #ececec;\r\n}\r\n\r\n\r\n.collabel{\r\n    margin-left: 260px;\r\n}\r\n\r\n\r\n.inputalign{\r\n    margin-left: -61px;\r\n\r\n}\r\n\r\n\r\n/* .center {\r\n    margin: auto;\r\n    width: 40%;\r\n    padding: 10px;\r\n    \r\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/allotment-cancellation/payment-details/payment-details.component.css
// module id = ./src/app/allocation/allotment-cancellation/payment-details/payment-details.component.css
// module chunks = main